import * as React from 'react';
import NewMultiroleLinkDialog from '../multirole-link/NewMultiroleLinkDialog';
import FreehandPenSettingDialog from '../drawing/freehand-pen/FreehandPenSettingDialog';
import ObjectDrawingSettingDialog from '../drawing/object-drawing/ObjectDrawingSettingDialog';
import ReflowableContentSettingDialog from '../reflowable-content/ReflowableContentSettingDialog';
import TextboxSettingDialog from '../textbox/TextboxSettingDialog';
import ReflowableContentSNEColorSettingDialog
  from '../reflowable-content/ReflowableContentSNEColorSettingDialog';

export enum DialogType {
  None,
  MultiroleLink,
  FreehandPen,
  ObjectDrawing,
  ReflowableContent,
  Textbox,
  ColorSetting,
}

interface SettingDialogContainerProps {
  dialogType: DialogType;
  setDialogType: (dialogType: DialogType) => void;
}

const SettingDialogContainer: React.SFC<
  SettingDialogContainerProps
> = React.memo((props) => {
  const attrs = {
    onClose: () => { props.setDialogType(DialogType.None); },
    setDialogType: props.setDialogType,
  };

  switch (props.dialogType) {
    case DialogType.None:
      return null;
    case DialogType.MultiroleLink:
      return <NewMultiroleLinkDialog { ...attrs } />;
    case DialogType.FreehandPen:
      return <FreehandPenSettingDialog { ...attrs } />;
    case DialogType.ObjectDrawing:
      return <ObjectDrawingSettingDialog { ...attrs } />;
    case DialogType.ReflowableContent:
      return <ReflowableContentSettingDialog { ...attrs } />;
    case DialogType.Textbox:
      return <TextboxSettingDialog { ...attrs } />;
    case DialogType.ColorSetting:
      return <ReflowableContentSNEColorSettingDialog { ...attrs } />;
  }
});

export default SettingDialogContainer;
